import { intrinsicClassName } from '../../utils/reactView';
import styles from './Backdrop.module.css';

export const Backdrop = intrinsicClassName('div', styles.backdrop);
